module.exports = __webpack_public_path__ + "media/assets/images/flags/sz-4fe9040d3854f406b76c407590102bc5.svg";